import React, { useState } from 'react';
import { Button, Col, Input, Label, Modal, ModalHeader } from 'reactstrap';

const ModalReactivateProposal = ({
  isOpen,
  toggle,
  handleSubmitReactivateProposal,
}) => {
  const [reason, setReason] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (reason) {
      handleSubmitReactivateProposal(reason);
      handleCleanupState();
    } else {
      setIsError(true);
    }
  };

  const handleCleanupState = () => {
    setReason('');
    setIsError(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>Reativar Proposta</ModalHeader>
      <div className="modal-body">
        <Col md={12}>
          <div className="mb-3">
            <Label htmlFor="detailsInput" className="form-label">
              Motivo
            </Label>
            <Input
              id="detailsInput"
              aria-multiline
              type="textarea"
              className="form-control"
              style={{
                height: 100,
              }}
              value={reason}
              invalid={isError && !reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </Col>

        <div className="text-end">
          <button
            className="btn btn-link"
            onClick={() => {
              toggle();
              setReason('');
            }}
            type="button"
          >
            Cancelar
          </button>
          <Button
            type="button"
            onClick={handleSubmit}
            className="btn btn-success"
          >
            Reativar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalReactivateProposal;
